var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leading-none mt-auto mb-2"},[_c('div',{staticClass:"text-6xl",domProps:{"innerHTML":_vm._s(_vm.time)}}),_vm._v(" "),_c('div',{staticClass:"text-4xl"},[_vm._v(_vm._s(_vm.date))])])
}
var staticRenderFns = []

export { render, staticRenderFns }